import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { PageTransitionWrapper } from './components/PageTransitionWrapper';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { Overview } from './pages/Overview';
import { PaymentRequests } from './pages/PaymentRequests';
import { Settings } from './pages/Settings';
import { VirtualTerminal } from './pages/VirtualTerminal';
import { PhysicalTerminals } from './pages/PhysicalTerminals';
import { SoftPosTerminals } from './pages/SoftPosTerminals';
import { Connect } from './pages/Connect';
import { Tutorials } from './pages/Tutorials';
import { TutorialDetail } from './pages/TutorialDetail';
import { Orders } from './pages/Orders';
import { Shops } from './pages/Shops';
import { ShopDetails } from './pages/ShopDetails';
import { Campaigns } from './pages/Campaigns';
import { CampaignDetails } from './pages/CampaignDetails';
import { CampaignForm } from './pages/CampaignForm';
import { PropertyInformation } from './pages/PropertyInformation';
import { Rooms } from './pages/Rooms';
import { AddRoom } from './pages/AddRoom';
import { EditRoom } from './pages/EditRoom';
import { RoomDetail } from './pages/RoomDetail';
import { Inventory } from './pages/Inventory';
import { Rates } from './pages/Rates';
import { Reservations } from './pages/Reservations';
import { ReservationDetail } from './pages/ReservationDetail';
import { BulkPayments } from './pages/BulkPayments';
import { BulkPaymentDetail } from './pages/BulkPaymentDetail';
import { Invoices } from './pages/Invoices';
import { InvoiceDetail } from './pages/InvoiceDetail';
import { InvoiceForm } from './pages/InvoiceForm';
import { Customers } from './pages/Customers';
import { CustomerDetail } from './pages/CustomerDetail';
import { CustomerForm } from './pages/CustomerForm';
import { Sales } from './pages/Sales';
import { SaleDetail } from './pages/SaleDetail';
import { Settlements } from './pages/Settlements';
import { SettlementDetail } from './pages/SettlementDetail';
import { Suppliers } from './pages/Suppliers';
import { SupplierDetail } from './pages/SupplierDetail';
import { SupplierForm } from './pages/SupplierForm';
import { Bills } from './pages/Bills';
import { BillDetail } from './pages/BillDetail';
import { BillForm } from './pages/BillForm';
import { BillApprovalWizard } from './pages/BillApprovalWizard';
import { BillFinancingWizard } from './pages/BillFinancingWizard';
import { DisputeDetail } from './pages/DisputeDetail';
import { Disputes } from './pages/Disputes';
import { RefundDetail } from './pages/RefundDetail';
import { Refunds } from './pages/Refunds';
export function AppRouter() {
  return <BrowserRouter data-id="element-2">
      <Routes data-id="element-3">
        <Route path="/" element={<Login data-id="element-5" />} data-id="element-4" />
        <Route path="/overview" element={<ProtectedRoute data-id="element-7">
              <AppLayout data-id="element-8">
                <PageTransitionWrapper data-id="element-9">
                  <Overview data-id="element-10" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-6" />
        <Route path="/payment-requests" element={<ProtectedRoute data-id="element-12">
              <AppLayout data-id="element-13">
                <PageTransitionWrapper data-id="element-14">
                  <PaymentRequests data-id="element-15" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-11" />
        <Route path="/bulk-payments" element={<ProtectedRoute data-id="element-17">
              <AppLayout data-id="element-18">
                <PageTransitionWrapper data-id="element-19">
                  <BulkPayments data-id="element-20" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-16" />
        <Route path="/bulk-payment-detail/:id" element={<ProtectedRoute data-id="element-22">
              <AppLayout data-id="element-23">
                <PageTransitionWrapper data-id="element-24">
                  <BulkPaymentDetail data-id="element-25" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-21" />
        <Route path="/settings" element={<ProtectedRoute data-id="element-27">
              <AppLayout data-id="element-28">
                <PageTransitionWrapper data-id="element-29">
                  <Settings data-id="element-30" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-26" />
        <Route path="/virtual-terminal" element={<ProtectedRoute data-id="element-32">
              <AppLayout data-id="element-33">
                <PageTransitionWrapper data-id="element-34">
                  <VirtualTerminal data-id="element-35" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-31" />
        <Route path="/physical-terminals" element={<ProtectedRoute data-id="element-37">
              <AppLayout data-id="element-38">
                <PageTransitionWrapper data-id="element-39">
                  <PhysicalTerminals data-id="element-40" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-36" />
        <Route path="/softpos-terminals" element={<ProtectedRoute data-id="element-42">
              <AppLayout data-id="element-43">
                <PageTransitionWrapper data-id="element-44">
                  <SoftPosTerminals data-id="element-45" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-41" />
        <Route path="/connect" element={<ProtectedRoute data-id="element-47">
              <AppLayout data-id="element-48">
                <PageTransitionWrapper data-id="element-49">
                  <Connect data-id="element-50" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-46" />
        <Route path="/tutorials" element={<ProtectedRoute data-id="element-52">
              <AppLayout data-id="element-53">
                <PageTransitionWrapper data-id="element-54">
                  <Tutorials data-id="element-55" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-51" />
        <Route path="/tutorial/:id" element={<ProtectedRoute data-id="element-57">
              <AppLayout data-id="element-58">
                <PageTransitionWrapper data-id="element-59">
                  <TutorialDetail data-id="element-60" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-56" />
        <Route path="/orders" element={<ProtectedRoute data-id="element-62">
              <AppLayout data-id="element-63">
                <PageTransitionWrapper data-id="element-64">
                  <Orders data-id="element-65" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-61" />
        <Route path="/shops" element={<ProtectedRoute data-id="element-67">
              <AppLayout data-id="element-68">
                <PageTransitionWrapper data-id="element-69">
                  <Shops data-id="element-70" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-66" />
        <Route path="/shop-details" element={<ProtectedRoute data-id="element-72">
              <AppLayout data-id="element-73">
                <PageTransitionWrapper data-id="element-74">
                  <ShopDetails data-id="element-75" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-71" />
        <Route path="/campaigns" element={<ProtectedRoute data-id="element-77">
              <AppLayout data-id="element-78">
                <PageTransitionWrapper data-id="element-79">
                  <Campaigns data-id="element-80" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-76" />
        <Route path="/campaign-details" element={<ProtectedRoute data-id="element-82">
              <AppLayout data-id="element-83">
                <PageTransitionWrapper data-id="element-84">
                  <CampaignDetails data-id="element-85" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-81" />
        <Route path="/campaign-form" element={<ProtectedRoute data-id="element-87">
              <AppLayout data-id="element-88">
                <PageTransitionWrapper data-id="element-89">
                  <CampaignForm data-id="element-90" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-86" />
        <Route path="/property-information" element={<ProtectedRoute data-id="element-92">
              <AppLayout data-id="element-93">
                <PageTransitionWrapper data-id="element-94">
                  <PropertyInformation data-id="element-95" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-91" />
        <Route path="/rooms" element={<ProtectedRoute data-id="element-97">
              <AppLayout data-id="element-98">
                <PageTransitionWrapper data-id="element-99">
                  <Rooms data-id="element-100" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-96" />
        <Route path="/add-room" element={<ProtectedRoute data-id="element-102">
              <AppLayout data-id="element-103">
                <PageTransitionWrapper data-id="element-104">
                  <AddRoom data-id="element-105" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-101" />
        <Route path="/edit-room" element={<ProtectedRoute data-id="element-107">
              <AppLayout data-id="element-108">
                <PageTransitionWrapper data-id="element-109">
                  <EditRoom data-id="element-110" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-106" />
        <Route path="/room-detail" element={<ProtectedRoute data-id="element-112">
              <AppLayout data-id="element-113">
                <PageTransitionWrapper data-id="element-114">
                  <RoomDetail data-id="element-115" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-111" />
        <Route path="/inventory" element={<ProtectedRoute data-id="element-117">
              <AppLayout data-id="element-118">
                <PageTransitionWrapper data-id="element-119">
                  <Inventory data-id="element-120" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-116" />
        <Route path="/rates" element={<ProtectedRoute data-id="element-122">
              <AppLayout data-id="element-123">
                <PageTransitionWrapper data-id="element-124">
                  <Rates data-id="element-125" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-121" />
        <Route path="/reservations" element={<ProtectedRoute data-id="element-127">
              <AppLayout data-id="element-128">
                <PageTransitionWrapper data-id="element-129">
                  <Reservations data-id="element-130" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-126" />
        <Route path="/reservation-detail" element={<ProtectedRoute data-id="element-132">
              <AppLayout data-id="element-133">
                <PageTransitionWrapper data-id="element-134">
                  <ReservationDetail data-id="element-135" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-131" />
        <Route path="/invoices" element={<ProtectedRoute data-id="element-137">
              <AppLayout data-id="element-138">
                <PageTransitionWrapper data-id="element-139">
                  <Invoices data-id="element-140" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-136" />
        <Route path="/invoice-detail/:id" element={<ProtectedRoute data-id="element-142">
              <AppLayout data-id="element-143">
                <PageTransitionWrapper data-id="element-144">
                  <InvoiceDetail data-id="element-145" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-141" />
        <Route path="/invoice-form" element={<ProtectedRoute data-id="element-147">
              <AppLayout data-id="element-148">
                <PageTransitionWrapper data-id="element-149">
                  <InvoiceForm data-id="element-150" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-146" />
        <Route path="/customers" element={<ProtectedRoute data-id="element-152">
              <AppLayout data-id="element-153">
                <PageTransitionWrapper data-id="element-154">
                  <Customers data-id="element-155" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-151" />
        <Route path="/customer-detail/:id" element={<ProtectedRoute data-id="element-157">
              <AppLayout data-id="element-158">
                <PageTransitionWrapper data-id="element-159">
                  <CustomerDetail data-id="element-160" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-156" />
        <Route path="/customer-form" element={<ProtectedRoute data-id="element-162">
              <AppLayout data-id="element-163">
                <PageTransitionWrapper data-id="element-164">
                  <CustomerForm data-id="element-165" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-161" />
        <Route path="/sales" element={<ProtectedRoute data-id="element-167">
              <AppLayout data-id="element-168">
                <PageTransitionWrapper data-id="element-169">
                  <Sales data-id="element-170" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-166" />
        <Route path="/sale-detail/:id" element={<ProtectedRoute data-id="element-172">
              <AppLayout data-id="element-173">
                <PageTransitionWrapper data-id="element-174">
                  <SaleDetail data-id="element-175" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-171" />
        <Route path="/settlements" element={<ProtectedRoute data-id="element-177">
              <AppLayout data-id="element-178">
                <PageTransitionWrapper data-id="element-179">
                  <Settlements data-id="element-180" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-176" />
        <Route path="/settlement-detail/:id" element={<ProtectedRoute data-id="element-182">
              <AppLayout data-id="element-183">
                <PageTransitionWrapper data-id="element-184">
                  <SettlementDetail data-id="element-185" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-181" />
        <Route path="/suppliers" element={<ProtectedRoute data-id="element-187">
              <AppLayout data-id="element-188">
                <PageTransitionWrapper data-id="element-189">
                  <Suppliers data-id="element-190" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-186" />
        <Route path="/supplier-detail/:id" element={<ProtectedRoute data-id="element-192">
              <AppLayout data-id="element-193">
                <PageTransitionWrapper data-id="element-194">
                  <SupplierDetail data-id="element-195" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-191" />
        <Route path="/supplier-form" element={<ProtectedRoute data-id="element-197">
              <AppLayout data-id="element-198">
                <PageTransitionWrapper data-id="element-199">
                  <SupplierForm data-id="element-200" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-196" />
        <Route path="/bills" element={<ProtectedRoute data-id="element-202">
              <AppLayout data-id="element-203">
                <PageTransitionWrapper data-id="element-204">
                  <Bills data-id="element-205" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-201" />
        <Route path="/bill-detail/:id" element={<ProtectedRoute data-id="element-207">
              <AppLayout data-id="element-208">
                <PageTransitionWrapper data-id="element-209">
                  <BillDetail data-id="element-210" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-206" />
        <Route path="/bill-form" element={<ProtectedRoute data-id="element-212">
              <AppLayout data-id="element-213">
                <PageTransitionWrapper data-id="element-214">
                  <BillForm data-id="element-215" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-211" />
        <Route path="/bill-approval/:id" element={<ProtectedRoute data-id="element-217">
              <AppLayout data-id="element-218">
                <PageTransitionWrapper data-id="element-219">
                  <BillApprovalWizard data-id="element-220" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-216" />
        <Route path="/bill-financing/:id" element={<ProtectedRoute data-id="element-222">
              <AppLayout data-id="element-223">
                <PageTransitionWrapper data-id="element-224">
                  <BillFinancingWizard data-id="element-225" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-221" />
        <Route path="/disputes" element={<ProtectedRoute data-id="element-227">
              <AppLayout data-id="element-228">
                <PageTransitionWrapper data-id="element-229">
                  <Disputes data-id="element-230" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-226" />
        <Route path="/dispute-detail/:id" element={<ProtectedRoute data-id="element-232">
              <AppLayout data-id="element-233">
                <PageTransitionWrapper data-id="element-234">
                  <DisputeDetail data-id="element-235" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-231" />
        <Route path="/refunds" element={<ProtectedRoute data-id="element-237">
              <AppLayout data-id="element-238">
                <PageTransitionWrapper data-id="element-239">
                  <Refunds data-id="element-240" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-236" />
        <Route path="/refund-detail/:id" element={<ProtectedRoute data-id="element-242">
              <AppLayout data-id="element-243">
                <PageTransitionWrapper data-id="element-244">
                  <RefundDetail data-id="element-245" />
                </PageTransitionWrapper>
              </AppLayout>
            </ProtectedRoute>} data-id="element-241" />
      </Routes>
    </BrowserRouter>;
}